/**
 * Set or clear one `data-*` attribute on the document root - the switches every stylesheet reads (the phase, the
 * danger, the rung, the motion). The one writer of `document.documentElement.dataset`.
 *
 * @param {string} name - the dataset key (`motion` is `data-motion`)
 * @param {string | number | null} value - null clears it
 */
export function wear(name, value) {
  const { dataset } = document.documentElement;
  if (value === null) delete dataset[name];
  else dataset[name] = String(value);
}
